// zoom-navigation-bubbez.js
// Navigation arrows for Horizon's <zoom-dialog> lightbox
// Starts on clicked image, stable sizing, Klaviyo Notify Me restored

(function () {
  // Store which image index was clicked before the dialog opens
  let dwZoomStartIndex = 0;

  function initZoomNavigation() {
    const zoomDialog = document.querySelector('zoom-dialog');
    if (!zoomDialog) return;

    // Don't initialize twice for the same dialog instance
    if (zoomDialog.querySelector('.custom-zoom-nav')) return;

    const dialog = zoomDialog.querySelector('dialog');
    const gallery = zoomDialog.querySelector('.dialog-zoomed-gallery');
    if (!dialog || !gallery) return;

    const slides = Array.from(gallery.querySelectorAll('li'));
    if (!slides.length || slides.length <= 1) {
      zoomDialog.setAttribute('data-single-image', 'true');
      return;
    }

    // Start from the slide that matches the clicked image index
    let currentIndex = 0;
    if (typeof dwZoomStartIndex === 'number' && slides.length > 0) {
      currentIndex = dwZoomStartIndex % slides.length;
      if (currentIndex < 0) currentIndex = 0;
    }

    // Show only the current slide
    function setActiveSlide() {
      slides.forEach((slide, idx) => {
        if (idx === currentIndex) {
          slide.classList.add('dw-zoom-active');
        } else {
          slide.classList.remove('dw-zoom-active');
        }
      });
    }

    // --- Create buttons ---

    const prevBtn = document.createElement('button');
    prevBtn.className = 'custom-zoom-nav custom-zoom-nav-prev';
    prevBtn.innerHTML =
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.setAttribute('type', 'button');

    const nextBtn = document.createElement('button');
    nextBtn.className = 'custom-zoom-nav custom-zoom-nav-next';
    nextBtn.innerHTML =
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.setAttribute('type', 'button');

    // --- Wrap-around helpers ---

    function goPrev() {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      setActiveSlide();
    }

    function goNext() {
      currentIndex = (currentIndex + 1) % slides.length;
      setActiveSlide();
    }

    // --- Event handlers ---

    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      goPrev();
    });

    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      goNext();
    });

    function handleKeyboard(e) {
      if (e.key === 'ArrowLeft') {
        goPrev();
      } else if (e.key === 'ArrowRight') {
        goNext();
      }
    }

    document.addEventListener('keydown', handleKeyboard);

    // Add buttons to dialog
    dialog.appendChild(prevBtn);
    dialog.appendChild(nextBtn);

    // Show the initial slide (based on what was clicked)
    setActiveSlide();

    // --- Cleanup when dialog closes ---

    const closeHandler = () => {
      currentIndex = 0;
      setActiveSlide();
      document.removeEventListener('keydown', handleKeyboard);
      prevBtn.remove();
      nextBtn.remove();
    };

    dialog.addEventListener('close', closeHandler);

    const closeBtn =
      dialog.querySelector('[data-ae-lb-close]') ||
      dialog.querySelector('button[onclick*="close"]') ||
      dialog.querySelector('button[aria-label="Close"]');

    if (closeBtn) {
      closeBtn.addEventListener('click', closeHandler);
    }
  }

  // Wait for dialog to be open, then initialize
  function waitForDialog() {
    const zoomDialogOpen = document.querySelector('zoom-dialog dialog[open]');
    if (zoomDialogOpen) {
      setTimeout(initZoomNavigation, 50);
    }
  }

  // Listen for clicks on zoomable images and remember which one was clicked
  document.addEventListener('click', (e) => {
    const zoomable = e.target.closest('.product-media-container--zoomable');
    if (zoomable) {
      // Find index of the clicked zoomable among all zoomables on the page
      const allZoomables = Array.from(
        document.querySelectorAll('.product-media-container--zoomable')
      );
      const clickedIndex = allZoomables.indexOf(zoomable);

      if (clickedIndex >= 0) {
        dwZoomStartIndex = clickedIndex;
      } else {
        dwZoomStartIndex = 0;
      }

      // Now wait for the dialog and init navigation at that index
      setTimeout(waitForDialog, 100);
    }
  });

  // Also run on page load in case dialog is already open
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForDialog);
  } else {
    waitForDialog();
  }

  // Re-run when Shopify sections reload (variant changes, etc.)
  document.addEventListener('shopify:section:load', () => {
    setTimeout(waitForDialog, 300);
  });
})();

// ===============================
// Bubbez – Notify Me → Klaviyo Popup (using link href selector)
// ===============================
document.addEventListener("DOMContentLoaded", function () {
  // Find ANY link/button that points to #notify-me
  const notifyLinks = document.querySelectorAll('a[href="#notify-me"], button[onclick*="#notify-me"]');

  if (!notifyLinks.length) return;

  notifyLinks.forEach(function (el) {
    el.addEventListener("click", function (e) {
      // Stop Shopify from jumping to the anchor
      e.preventDefault();
      e.stopPropagation();

      // Open Klaviyo form
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", "WwQYvs"]); // <-- replace with your DESKTOP form ID
    });
  });
});

/* ===================================
   Free Shipping Progress Bar
   =================================== */

(function() {
  class FreeShippingProgress {
    constructor() {
      this.threshold = 4999; // $49.99 in cents
      this.init();
    }

    init() {
      // Listen for ALL possible cart update events
      document.addEventListener('cart:updated', () => this.update());
      document.addEventListener('cart:refresh', () => this.update());
      document.addEventListener('cart:change', () => this.update());
      
      // Shopify Ajax Cart events
      document.addEventListener('ajaxCart:updated', () => this.update());
      
      // Watch for DOM changes (when cart drawer re-renders)
      this.observeCartDrawer();
      
      // Initial load
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.update());
      } else {
        setTimeout(() => this.update(), 100);
      }
    }

    observeCartDrawer() {
      // Use MutationObserver to detect when cart drawer content changes
      const observer = new MutationObserver(() => {
        const container = document.querySelector('[data-free-shipping-progress]');
        if (container && !container.hasChildNodes()) {
          // Container exists but is empty - re-render
          this.update();
        }
      });

      // Start observing the document body for changes
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    async update() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        this.render(cart.total_price);
      } catch (error) {
        console.warn('Free shipping progress error:', error);
      }
    }

    render(cartTotal) {
      const container = document.querySelector('[data-free-shipping-progress]');
      if (!container) {
        // Container doesn't exist yet, try again in a moment
        setTimeout(() => this.render(cartTotal), 200);
        return;
      }

      const remaining = this.threshold - cartTotal;
      const progress = Math.min((cartTotal / this.threshold) * 100, 100);

      if (remaining > 0) {
        container.innerHTML = `
          <div class="fs-progress-wrapper">
            <p class="fs-progress-text">
              You're <strong>${this.formatMoney(remaining)}</strong> away from free shipping
            </p>
            <div class="fs-progress-bar">
              <div class="fs-progress-fill" style="width: ${progress}%"></div>
            </div>
            <div class="fs-progress-labels">
              <span>$0</span>
              <span>$${this.threshold / 100} Free Shipping</span>
            </div>
          </div>
        `;
      } else {
        container.innerHTML = `
          <div class="fs-progress-wrapper">
            <p class="fs-progress-success">
              🎉 You unlocked FREE shipping!
            </p>
          </div>
        `;
      }
    }

    formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  // Initialize
  new FreeShippingProgress();
})();

